export default {
      id: "alert-icon-danger-usage",
      viewBox: "0 0 28 25",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#alert-icon-danger",
      toString: function () {
        return this.url;
      }
    }